import axios from 'axios';
import appConfig from '@/config';
import { getCookie } from '@/utils/auth/authService';
const BASE_URL = appConfig.api.base;


export function getAprrovalStatus(perPage = 10, page = 1, status = 'pending', para = {}, download = 0){
    console.log(download)
    const url = `${BASE_URL}/approvals`;
    let token = getCookie('token');
    let merchantId = window.localStorage.getItem('merchantId');
    return axios({
        method: 'get',
        url: url,
        headers: {
            'Content-Type': 'application/json',
            'Authorization':token,
            'merchant-id':merchantId
        },
        params:{
            per_page:perPage,
            page:page,
            para:para,
            status: status,
            download,
        }
    });
}
export function getAprroval( id, download = 1){
    let url = `${BASE_URL}/approvals/${id}`;
    if(download === 1){
        url += '?download=1'
    }
    let token = getCookie('token');
    let merchantId = window.localStorage.getItem('merchantId');
    return axios({
        method: 'get',
        url: url,
        headers: {
            'Content-Type': 'application/json',
            'Authorization':token,
            'merchant-id':merchantId
        },
        
    });
}

export function approved(approvalId, action, reason, type){
    const url = `${BASE_URL}/payouts/approval`;
    let token = getCookie('token');
    let merchantId = window.localStorage.getItem('merchantId');
    console.log(approvalId, action, reason, type);
    return axios({
        method: 'post',
        url: url,
        headers: {
            'Content-Type': 'application/json',
            'Authorization':token,
            'merchant-id':merchantId
        },
        data: {
            approvalId: approvalId,
            action: action,
            reason: reason,
            type: type,
        }
    })
}
export function changeApprovalStatus(batchId, refs, cancel){
    const url = `${BASE_URL}/payouts/approval/status`;
    let token = getCookie('token');
    let merchantId = window.localStorage.getItem('merchantId');
    return axios({
        method: 'post',
        url: url,
        headers: {
            'Content-Type': 'application/json',
            'Authorization':token,
            'merchant-id':merchantId
        },
        data: {
            batchId,
            refs,
            cancel,
        }
    })
}

export function cancel(id){
    const url = `${BASE_URL}/verified`;
    let token = getCookie('token');
    let merchantId = window.localStorage.getItem('merchantId');
    return axios({
        method: 'post',
        url: url,
        headers: {
            'Content-Type': 'application/json',
            'Authorization':token,
            'merchant-id':merchantId
        },
        data: {
            merchantId: merchantId,
            fieldsAndInputs: dataObj
        }
    })
}


// WEBPACK FOOTER //
// ./src/utils/approvals/approvalsServices.js